/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { keywordState } from "./keyword.state";

const keyword = createSlice({
    
    name: "keyword",
    
    initialState: keywordState,
    
    reducers: {
        setCurrentKeywords (state, action) {
            const keyword = action.payload;
            state.current = keyword.current;
        },
        setAllKeywords (state, action) {
            const keyword = action.payload;
            state.all = keyword.all;
        },
    },
    
});


export const selectAllKeywords = (state) => {
    return state.keyword.all;
};
export const currentKeywordsSelector = (state) => {
    return state.keyword.current;
};

export const keywordReducer = keyword.reducer;

export const { setCurrentKeywords, setAllKeywords } = keyword.actions;
